import React, { useEffect, useState } from 'react';
import './LessonDetail.css';

export default function LessonDetail({ topic, navigate }) {
  const [lesson, setLesson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(0);

  useEffect(() => {
    if (!topic) { navigate('lessons'); return; }
    fetch(`/api/lessons/${topic.id}`)
      .then(r => r.json())
      .then(data => { setLesson(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [topic]);

  if (loading) return <div className="loading-state">Loading lesson...</div>;
  if (!lesson) return <div className="loading-state">Lesson not found.</div>;

  return (
    <div className="lesson-detail">
      <button className="btn btn-ghost" onClick={() => navigate('lessons')} style={{ marginBottom: 16 }}>
        &#8592; Back to Topics
      </button>

      <div className="lesson-header card">
        <div className="lesson-meta">
          <span className={`badge-difficulty ${topic.difficulty?.toLowerCase()}`}>{topic.difficulty}</span>
          <span className="topic-xp-badge">+{topic.xp_reward} XP on completion</span>
        </div>
        <h1 className="lesson-title">{lesson.title}</h1>
        <p className="lesson-intro">Work through each section, then test your knowledge with a quiz.</p>

        <div className="lesson-actions">
          <button className="btn btn-primary" onClick={() => navigate('quiz', topic)}>
            Take Quiz &#8594;
          </button>
        </div>
      </div>

      <div className="lesson-sections">
        {lesson.sections.map((section, idx) => (
          <div
            key={idx}
            className={`lesson-section card ${expanded === idx ? 'open' : ''}`}
          >
            <button
              className="section-toggle"
              onClick={() => setExpanded(expanded === idx ? -1 : idx)}
            >
              <div className="section-num">{idx + 1}</div>
              <span className="section-toggle-title">{section.title}</span>
              <span className="section-arrow">{expanded === idx ? '▲' : '▼'}</span>
            </button>

            {expanded === idx && (
              <div className="section-body animate-in">
                <p className="section-content">{section.content}</p>
                <div className="key-points">
                  <div className="key-points-label">Key Points</div>
                  <ul className="key-points-list">
                    {section.key_points.map((kp, i) => (
                      <li key={i} className="key-point">
                        <span className="kp-icon">&#9670;</span>
                        {kp}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="lesson-cta card">
        <h3>Ready to test your knowledge?</h3>
        <p>Take the quiz to earn XP and unlock achievements!</p>
        <button className="btn btn-primary btn-lg" onClick={() => navigate('quiz', topic)}>
          Start Quiz &#8594;
        </button>
      </div>
    </div>
  );
}
